export var mutations = {
    setCandidate: function (s, payload) { return s.candidate = payload; },
    setJob: function (s, payload) { return s.job = payload; },
    setTalentLoading: function (s, payload) { return s.loading.talent = payload; },
    setFilesLoading: function (s, payload) { return s.loading.files = payload; },
    setFormsLoading: function (s, payload) { return s.loading.forms = payload; },
    setThreadLoading: function (s, payload) { return s.loading.thread = payload; },
    setThreadsLoading: function (s, payload) { return s.loading.threads = payload; },
    setTimelineLoading: function (s, payload) { return s.loading.timeline = payload; },
    setForms: function (s, payload) { return s.forms = payload; },
    setFiles: function (s, payload) { return s.files = payload; },
    setThreads: function (s, payload) { return s.threads = payload; },
    setSelectedThread: function (s, payload) { return s.selectedThread = payload; },
    setTimeline: function (s, payload) { return s.timeline = payload; },
};
